import { Button, FlatButton } from 'bz-core-controls';

import Colours from 'bz-core-controls/styles/colours';
import React from 'react';

export interface IConfirmationProps {
  className: string;
  abortLabel: string;
  confirmLabel: string;
  errors: string[];
  warningsText: string;

  abort: (e: React.MouseEvent<any>) => void;
  confirm: (e: React.MouseEvent<any>, v: any) => void;
}

class ErrorPanel extends React.Component<IConfirmationProps> {
  render() {
    const { className } = this;
    const { abortLabel, confirmLabel, errors, warningsText } = this.props;
    const errorsList = errors.map((err, i) => {
      return <li key={i}>{err}</li>;
    });

    return (
      <div className={`${className} root appt-error-panel`}>
        <h3 className={`${className} title`}>{warningsText}</h3>
        <div className={`${className} content`}>
          <ul>{errorsList}</ul>
          <FlatButton onClick={this.props.abort}>{abortLabel}</FlatButton>
          <Button onClick={this.props.confirm} backgroundColor={Colours.red900} primary={true}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    );
  }

  private get className(): string {
    return `${this.props.className} errors-panel`;
  }
}

export default ErrorPanel;
